module.exports = __webpack_public_path__ + "media/images/basicinfo_ic-055b5cf1bd358bbfda6e43d9c478ebbe.svg";